<sh-action-group *ngIf="showActionGroup && toggleActionGroup" [actionGroup]="toggleActionGroup" [childComponentClasses]="childComponentClasses">
</sh-action-group>
